import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { useLang } from "../context/LanguageContext";

export function Consent({ name, register, errors }) {
  const { t } = useLang();
  return (
    <div className="md:col-span-2" data-testid={`field-${name}`}>
      <label className="flex items-start gap-3 cursor-pointer" htmlFor={name}>
        <input
          id={name}
          type="checkbox"
          className="w-[14px] h-[14px] mt-[3px] accent-[#D1C7BD] cursor-pointer shrink-0"
          data-testid={`input-${name}`}
          {...register(name, { required: t("forms.required") })}
        />
        <span className="text-[12px] text-[#999995] leading-relaxed">
          {t("sell.consentBefore")}{" "}
          <Link to="/privacy-policy" className="text-[#D1C7BD] underline underline-offset-4 hover:text-[#F3F3F0] transition-colors" data-testid={`${name}-link`}>
            {t("sell.privacyLink")}
          </Link>
          {t("sell.consentAfter")}
        </span>
      </label>
      {errors?.[name] && (
        <p className="mono text-[10px] text-[#D1C7BD] mt-1.5 tracking-[0.14em] uppercase">
          {errors[name].message || t("forms.required")}
        </p>
      )}
    </div>
  );
}

export function Field({ label, name, register, errors, type = "text", required = false, span = 1 }) {
  const { t } = useLang();
  return (
    <div className={span === 2 ? "md:col-span-2" : ""} data-testid={`field-${name}`}>
      <label className="field-label" htmlFor={name}>{label} {required && <span className="text-[#D1C7BD]">*</span>}</label>
      <input
        id={name}
        type={type}
        data-testid={`input-${name}`}
        className="field-input"
        {...register(name, {
          required: required ? t("forms.required") : false,
          ...(type === "email" ? { pattern: { value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/, message: "invalidEmail" } } : {}),
        })}
      />
      {errors?.[name] && (
        <p className="mono text-[10px] text-[#D1C7BD] mt-1.5 tracking-[0.14em] uppercase">
          {errors[name].message || t("forms.required")}
        </p>
      )}
    </div>
  );
}

export function TextArea({ label, name, register, span = 2 }) {
  return (
    <div className={span === 2 ? "md:col-span-2" : ""} data-testid={`field-${name}`}>
      <label className="field-label" htmlFor={name}>{label}</label>
      <textarea id={name} rows={3} data-testid={`input-${name}`} className="field-input" {...register(name)} />
    </div>
  );
}

export function SuccessPanel({ onAgain, title, body, again, testid }) {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.98 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
      className="border border-white/15 bg-[#0D0E0F] p-10 md:p-16 text-center"
      data-testid={testid}
    >
      <svg width="40" height="40" viewBox="0 0 40 40" className="mx-auto mb-6" fill="none">
        <circle cx="20" cy="20" r="19" stroke="#D1C7BD" strokeWidth="1" />
        <motion.path
          d="M12 20.5 L17.5 26 L28 14.5"
          stroke="#D1C7BD"
          strokeWidth="1.6"
          initial={{ pathLength: 0 }}
          animate={{ pathLength: 1 }}
          transition={{ duration: 0.8, delay: 0.3, ease: "easeOut" }}
        />
      </svg>
      <h3 className="font-display text-2xl md:text-3xl text-[#F3F3F0] mb-3">{title}</h3>
      <p className="text-[14px] text-[#999995] max-w-md mx-auto mb-8">{body}</p>
      <button onClick={onAgain} className="btn" data-testid={`${testid}-again`}>{again}</button>
    </motion.div>
  );
}
